import { render } from "./DocumentValidationComp.vue?vue&type=template&id=ff52aa2c"
import script from "./DocumentValidationComp.vue?vue&type=script&lang=js"
export * from "./DocumentValidationComp.vue?vue&type=script&lang=js"
script.render = render

export default script
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QBtn});
